export const flightFreeBaggageType = {
  all: "Include in all itineraries",
  partial: "Include in some itineraries",
};
